module.exports = __webpack_public_path__ + "static/media/alert.5e126e20.svg";